"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MapIconMain = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * SVG main element (pin, circle or double circle)
 * @param props MapIconMainProps
 * @returns JSX.Element
 */
const MapIconMain = props => {
  const {
    pinColor,
    iconType,
    clusterSize
  } = props;
  const pointer = /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5 20.9734C5 12.1617 11.6867 4 21 4C30.1142 4 37 12.1506 37 20.9734L36.9994 21.0122C36.8621 25.458 34.7586 30.1822 32.1153 34.152C29.4677 38.1282 26.1535 41.5345 23.3734 43.3072C21.9139 44.2378 20.0811 44.2243 18.6308 43.3066C15.8269 41.5325 12.5113 38.1747 9.86647 34.2178C7.22491 30.2657 5.13773 25.5449 5.00058 21.0114L5 20.9734Z",
    fill: pinColor
  });
  const mainIcon = {
    cluster: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "23.746",
        cy: "22.5298",
        r: "18.5",
        fill: pinColor
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
        textAnchor: "middle",
        x: "23.746",
        y: "27.5298",
        fontSize: "14px" // it is used in canvas so most likely this is needed size
        ,
        fontFamily: "SansOri, SansOriFallback, sans-serif",
        fontWeight: "700",
        fill: _mui.theme.palette.common.white,
        children: clusterSize
      })]
    }),
    currentLocation: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "25",
        cy: "25",
        r: "25",
        fill: pinColor,
        fillOpacity: "0.2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "25",
        cy: "25",
        r: "10",
        fill: pinColor
      })]
    }),
    pin: pointer,
    pickup: pointer,
    post: pointer,
    spo: pointer
  };
  if (iconType === 'currentLocation') {
    return mainIcon.currentLocation;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    filter: "url(#shadow)",
    children: mainIcon[iconType]
  });
};
exports.MapIconMain = MapIconMain;
var _default = exports.default = MapIconMain;
